/* eslint-disable */
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import SpinnerPropsTypes from './Spinner.component.props';
import spinnerStyles from './Spinner.component.styles';

/**
 * SpinnerComponent
 * @export
 * @class SpinnerComponent
 * @extends {React.Component<SpinnerComponentComposedProps, SpinnerComponentState>}
 */
export class SpinnerComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<SpinnerComponentProps>}
   * @memberof SpinnerComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Spinner`}
   * @memberof SpinnerComponent
   */
  static displayName = `Spinner`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof SpinnerComponent
   */
  static propTypes = SpinnerPropsTypes;

  /**
   * Data specific to the `<SpinnerComponent />` instance
   * @type {SpinnerComponentState}
   * @memberof SpinnerComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<SpinnerComponent />`
   * @memberof SpinnerComponent
   */
  render() {
    const { classes, loaderStyles, ...props } = this.props;
    return (
      <Grid alignItems="center" classes={{ container: loaderStyles || classes.loader }} container justify="center">
        <CircularProgress {...props} />
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<SpinnerComponentProps>} */
const Spinner = compose(withStyles(themeCreateInjectableStyles(spinnerStyles), { withTheme: true }))(SpinnerComponent);

export default Spinner;
